import { cn } from "@hipotecar/ui/lib/utils";
import {
	tableCellPadding,
	tableContainer,
	tableHeaderRow,
} from "@/components/composed/DataTable/styles";

function Block({ className = "" }: { className?: string }) {
	return (
		<div
			className={`animate-pulse rounded-sm bg-gray-200/80 dark:bg-slate-800/70 ${className}`}
		/>
	);
}

const CELL_PADDING = tableCellPadding({ density: "compact" });

/**
 * Loading placeholder for the Alquiler/Gastos table. Borrows the real table's
 * container, header and cell padding tokens so the skeleton and the loaded
 * table occupy the same box — no layout shift / scroll flash on load.
 */
export default function FinancialTableSkeleton({ rows = 3 }: { rows?: number }) {
	return (
		<div className={tableContainer}>
			{/* Header */}
			<div
				className={cn(
					"flex items-center gap-4",
					tableHeaderRow,
					CELL_PADDING,
				)}
			>
				<Block className="h-3 w-24 flex-1" />
				<Block className="h-3 w-16" />
				<Block className="h-3 w-20" />
				<div className="w-12" />
			</div>

			{/* Rows */}
			{Array.from({ length: rows }).map((_, i) => (
				<div
					key={i}
					className={cn(
						"flex items-center gap-4 border-t border-gray-100 dark:border-white/5",
						CELL_PADDING,
					)}
				>
					<div className="flex-1 space-y-1.5">
						<Block className="h-3.5 w-32" />
						<Block className="h-2.5 w-20" />
					</div>
					<div className="w-16 space-y-1.5">
						<Block className="h-3.5 w-16" />
						<Block className="h-2.5 w-12" />
					</div>
					<div className="w-20">
						<Block className="h-3.5 w-24" />
					</div>
					<div className="flex w-12 justify-end gap-2">
						<Block className="size-5" />
						<Block className="size-5" />
					</div>
				</div>
			))}
		</div>
	);
}
